import React from 'react';
import styles from './footer.module.scss';

const Footer = () => (
  <footer className={styles.footer}>
    <p>&copy; 2019 <a href="http://getwalk.in">First WalkIn Technologies Pvt Ltd</a></p>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js